import React from 'react';
import Sidebar from './sidebar';
import { Layout } from '../components';
import AppHeader from './components/Header';
import { Breadcrumbs } from '../components';
import { LayoutProvider } from './context/LayoutContext';
import { SessionTimeoutProvider } from '../providers/SessionTimeoutProvider';
import { NotificationsPanelProvider } from '../providers/NotificationsPanelProvider';
import './styles/layout.scss';

const { Content } = Layout;

const AppLayout = ({ children }) => {
    return (
        <SessionTimeoutProvider>
            <NotificationsPanelProvider>
            <LayoutProvider>
                <Layout className="rm-layout">
                    <Sidebar />
                    <Layout>
                        <AppHeader />
                        <Breadcrumbs />
                        <Content id="react_root" className="app-content">
                            {children}
                        </Content>
                    </Layout>
                </Layout>
            </LayoutProvider>
            </NotificationsPanelProvider>
        </SessionTimeoutProvider>
    );
};

export default AppLayout;
